import { Usuario } from './../usuario/usuario.model';
import { Grupo } from "../grupo/grupo.model";
import { SetorVinculoBase } from "./setor-vinculo-base.model";

export class Setor{
  id!: number;
  nome!: string;
  descricao?: string;
  grupo?: Grupo;
  ativo!: boolean;

  bases?: SetorVinculoBase[];

  dataCriacao?: Date
  usuarioCriacao?: Usuario
  dataAlteracao?: Date
  usuarioAlteracao?: Usuario
}
